import React from 'react'
import { InvestSuccessBtn } from 'src/components/Global/Button/Button'
import { InvestSuccess } from 'src/assets/index'
import {
  SuccessModalContainer,
  SuccessWrapper,
  SuccessModalBackground,
  SuccessContentWrapper,
} from 'src/components/Payment/PaymentResults/InvestmentSuccess/style'
import { Link } from 'react-router-dom'
import { XContestTypes } from 'src/redux/types/xContest'
import { useDispatch } from 'react-redux'
import { action } from 'typesafe-actions'

const XContestSuccess = ({ showSuccessModal, title }: any) => {
  const dispatch = useDispatch()

  const handleClearForm = () => {
    dispatch(action(XContestTypes.CLEAR_CONTEST_DATA))
  }

  return (
    <div>
      <SuccessModalContainer>
        {showSuccessModal ? (
          <SuccessModalBackground>
            <SuccessWrapper>
              <SuccessContentWrapper>
                <div className="success_svg">
                  <img src={InvestSuccess} alt="" />
                </div>
                <div className="success_content">
                  <div className="success_text">
                    <p className="awesome">Awesome</p>
                    <p className="process_text">{title}</p>
                  </div>
                </div>

                <div className="btn_wrapper">
                  <Link to="/homepage">
                    <InvestSuccessBtn onClick={handleClearForm}>
                      Return to home
                    </InvestSuccessBtn>
                  </Link>
                </div>
              </SuccessContentWrapper>
            </SuccessWrapper>
          </SuccessModalBackground>
        ) : null}
      </SuccessModalContainer>
    </div>
  )
}

export default XContestSuccess
